import React from "react";

export default function Footer() {
    return (
        <footer style={{ background: "#f5f5f5", padding: "40px 0" }}>
            <div className="container"

            >
                <div
                    className="footer-inner"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        gap: "20px",
                    }}
                >
                    {/* Logo Column */}
                    <div
                        className="footer-col footer-1"
                        style={{ flex: "1 1 220px", textAlign: "center" }}
                    >
                        <div className="footer-logo">
                            <a href="https://nab.gov.pk" className="nab-link">
                                <img
                                    src="/images/nab_logo.png"
                                    className="nab-logo"
                                    alt="NAB Logo"
                                    style={{
                                        maxWidth: "160px",
                                        height: "auto",
                                        marginTop: "-28px",
                                    }}
                                />
                            </a>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div
                        className="footer-col footer-2 footer-menu-section"
                        style={{ flex: "1 1 220px" }}
                    >
                        <ul className="footer-menu list-unstyled">
                            <li>
                                <a href="tel:+92519207799" className="menu-link text-dark">
                                    <i className="fas fa-phone me-2"></i>
                                    <span>051-9207799</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:webmaster@nab.gov.pk"
                                    className="menu-link text-dark"
                                >
                                    <i className="fas fa-envelope me-2"></i>
                                    <span>webmaster@nab.gov.pk</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Address Section */}
                    <div
                        className="footer-col footer-3 footer-menu-section"
                        style={{ flex: "1 1 280px" }}
                    >
                        <h3 className="fw-semibold text-dark">Address</h3>
                        <ul className="footer-menu list-unstyled">
                            <li>
                                <a
                                    href="https://maps.app.goo.gl/waWsP6Y2uhUbnude6"
                                    className="menu-link text-dark"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fas fa-map-marker-alt me-2"></i>
                                    <span>
                    National Accountability Bureau (NAB), Shahrah-e-Jamhuriat,
                    G-5/1, Islamabad.
                  </span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Complaint Info */}
                    <div
                        className="footer-col footer-4 footer-menu-section"
                        style={{ flex: "1 1 220px" }}
                    >
                        <h3 className="fw-semibold text-dark">For Complaint</h3>
                        <ul className="footer-menu list-unstyled">
                            <li>
                                <a href="tel:+92111622622" className="menu-link text-dark">
                                    UAN: 111-622-622
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:chairman@nab.gov.pk"
                                    className="menu-link text-dark"
                                >
                                    Email: chairman@nab.gov.pk
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://nab.gov.pk/online-complaint/"
                                    className="menu-link text-dark"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Online Complaint Registration
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}
